import  {useContext  } from 'react';
import {AppContext} from "../context/appContext";

export const UsePermissions = () => {
    const {user} = useContext(AppContext);

    const permisos = {
        submenu: user.submenu,
        consultar: user.consultar,
        editar: user.editar,
        eliminar: user.eliminar,
        adicionar: user.adicionar
    }

    return [permisos];

};


